import React from "react";
import styles from "./loading.module.css";

const Loading = () => {
  return (
    <div className={`${styles.messageRow} ${styles.left}`}>           
      <div className={styles.typingContainer}>
        <span className={styles.dot}></span>
        <span className={styles.dot}></span>
        <span className={styles.dot}></span>
      </div>
    </div>
  );
};

export default Loading;
